import React from 'react';

import ContentLoader from '@adsk/alloy-react-content-loader';

const ResultsLoader = () => (
  <ContentLoader width={100} height={10} viewBox="0 0 100 10">
    <rect x="0" y="3" rx="3" ry="3" width="100" height="6" />
  </ContentLoader>
);

ResultsLoader.displayName = 'ResultsLoader';

export default ResultsLoader;
